import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { useLang } from "@/context/LanguageContext";
import { LogoIcon, LogoText } from "./LogoIcon";

const LANGUAGES = [
  { code: "en", flag: "🇬🇧", label: "English" },
  { code: "es", flag: "🇪🇸", label: "Español" },
];

export default function Header() {
  const { lang, setLang } = useLang();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      data-testid="main-header"
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#050505]/80 backdrop-blur-xl border-b border-white/5"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <button
            data-testid="logo-button"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="flex items-center gap-2.5 group"
          >
            <LogoIcon size={36} className="transition-transform duration-300 group-hover:scale-110" />
            <LogoText className="hidden sm:block" height={28} />
          </button>

          {/* Right Controls */}
          <div className="flex items-center gap-2">
            <div className="relative flex items-center">
              <select
                data-testid="language-select"
                value={lang}
                onChange={(e) => setLang(e.target.value)}
                className="appearance-none pl-3 pr-6 py-1.5 text-xs font-bold uppercase tracking-wider text-white/70 hover:text-white bg-transparent border border-white/10 hover:border-brand-cyan/50 rounded transition-all duration-300 cursor-pointer focus:outline-none focus:border-brand-cyan/50"
                style={{ colorScheme: "dark" }}
              >
                {LANGUAGES.map((l) => (
                  <option key={l.code} value={l.code} className="bg-[#0a0a0a] text-white">
                    {l.flag} {l.label}
                  </option>
                ))}
              </select>
              <span className="absolute right-1.5 pointer-events-none text-white/40 text-[10px]">▾</span>
            </div>
          </div>
        </div>
      </div>
    </motion.header>
  );
}
